/* eslint-disable max-params */
import React, { ReactNode } from "react";
import Revoke from "@/components/chat/message/Revoke";
import Text from "@/components/chat/message/Text";
import HttpCard from "@/components/chat/message/HttpCard";
import Image from "@/components/chat/message/Image";
import UploadFile from "@/baseComponents/Chat/message/File/Upload";
import DownloadFile from "@/baseComponents/Chat/message/File/Download";
import Video from "@/components/chat/message/Video";
import Voice from "@/components/chat/message/Voice";
import Share from "@/components/chat/message/share";
import NoticeCard from "@/components/chat/message/NoticeCard";
import SysMessage from "@/components/chat/message/Sys";
import JoyspaceFile from "../message-components/JoyspaceFile";
import UnSupport from "@/components/chat/message/UnSupport";
import Location from "@/components/chat/message/Location";
import { ChatMessageType, Session, MessageEmitCategory, ChatMessage, SessionType } from "@/types/chat";
import { MessageSendType } from "@/types/chat/enum";
import {
  checkMessageSupport,
  convertEmployeeToString,
  employeeToUid,
  FILE_DOWNLOAD_BIZTYPE,
  initChatMessageInfo,
  isSameClient
} from "@/utils/chat/message";
import { isFocusEnv } from "@/utils";
import GroupNotificationCard from "../GroupNotificationCard";
import SolitaireCard from "../SolitaireCard";
import JoyspaceFolder from "../message-components/JoyspaceFolder";
import { openPicker as openCategoriesPicker } from "@/components/Joyspace/components/CategoriesPickerTree";
import { message as toast, Modal } from "antd";
import { lang } from "@/components/Joyspace/context";
import ImService from "@/server/ImService";
import { pageTransfer, pageTransferCheck } from "@/api/joyspace";
import { UserModel } from "@/models/user";
import { analysisLog } from "@/utils/logAnalytics";
import { handleAddFileDownloadRecord } from "../../utils/commonMessageModal";
import { parseUidFromString } from "@jd/focus-desktop-comps/lib/es/utils";

function getMessageItemProps(
  message: any,
  sendType: MessageSendType,
  currentSession: Session
): any {
  return {
    message: message,
    sendType: sendType,
    sessionType: currentSession.sessionType
    // onReady: messageReady,
  };
}

/**
 * 转存到我的文档/组空间
 */
function getCaption(obj: any) {
  let index = obj.lastIndexOf("=");
  // eslint-disable-next-line no-param-reassign
  obj = obj.substring(index + 1, obj.length);
  //  console.log(obj);
  return obj;
}
const handlePageTransfer = async (
  transferParames: any,
  checkParames: any,
  close: Function,
  message: any,
  updateSessionMessageMid: Function,
  selectedSession: Session,
  currentEmployee: any
) => {
  const imService = ImService.getInstance();
  pageTransferCheck(checkParames)
    .then((data: any) => {
      if (!data) {
        Modal.confirm({
          title: `此位置已经存在名称为「${transferParames.fileName}」的文件，确认要重复存储吗？`,
          cancelText: lang("common.cancel"),
          okText: lang("common.confirm"),
          onOk: () => {
            pageTransfer(transferParames)
              .then((res: any) => {
                const { data } = res;
                if (!data) {
                  const { status } = res;
                  toast.error(status);
                  return;
                }
                if (data) {
                  const { transferCode } = data;
                  toast.success("文件转存中，请稍后查看");
                  message.docId = transferCode;
                  imService?.saveJoyspace(message);
                  updateSessionMessageMid({
                    sessionId: selectedSession.sessionId,
                    sendResult: { body: { ...message, docId: transferCode } }
                  });
                  handleAddFileDownloadRecord(message, currentEmployee, 2, selectedSession);
                  close();
                }
              })
              .catch((err) => {
                toast.error(err.message.toString());
              });
          }
        });
      } else {
        pageTransfer(transferParames)
          .then((res: any) => {
            const { data } = res;
            if (!data) {
              const { status } = res;
              toast.error(status);
              return;
            }
            if (data) {
              const { transferCode } = data;
              toast.success("文件转存中，请稍后查看");
              message.docId = transferCode;
              imService?.saveJoyspace(message);
              updateSessionMessageMid({
                sessionId: selectedSession.sessionId,
                sendResult: { body: { ...message, docId: transferCode } }
              });
              handleAddFileDownloadRecord(message, currentEmployee, 2, selectedSession);
              close();
            }
          })
          .catch((err) => {
            toast.error(err.message.toString());
          });
      }
    })
    .catch((err) => {
      toast.error(err.message.toString());
    });
};
// 文件转存到文档协同/组空间
export const handleTransferTo = async (
  message: any,
  selectedSession: Session,
  currentEmployee: any,
  groupCreate: any,
  appRuntimeEnv: any,
  userData: UserModel,
  updateSessionMessageMid: Function
) => {
  if (message.type === ChatMessageType.FILE) {
    if (selectedSession.isGroup) {
      await groupCreate();
    }
    let fileMsg: any = message;
    openCategoriesPicker({
      isMoveSave: true,
      defaultNav: selectedSession.isGroup
        ? [
            {
              name: selectedSession.info.name,
              id: selectedSession.id,
              icon: "iconapp_btn_folder",
              level: 1,
              isLeaf: false,
              type: 3,
              disabled: false,
              selectable: true
            }
          ]
        : null,
      title: fileMsg.name || "无标题",
      canSelectMy: true,
      isTeam: selectedSession.isGroup,
      appRuntimeEnv: appRuntimeEnv,
      callback: async ({ id, type, rootId, tabKey }, close) => {
        let spaceId: any;
        let categoryId: any;

        // 如果是到共享文件夹需要判断是不是到根文件夹
        if (type === 12) {
          // spaceId = rootId;
          categoryId = id;
        } else {
          // 如果是到我的文件夹需要都置空
          categoryId = id === "root" ? "" : id;
        }
        Modal.confirm({
          title: lang("ctx.addTo.tip"),
          // content:
          //     '移动后将取消原文件夹协作者的共享，并重新共享给目标文件夹的协作者。',
          cancelText: lang("common.cancel"),
          okText: lang("common.confirm"),
          onOk: () => {
            analysisLog(
              "xtbg_jzb_joysapce_inOtherModule_1676971574856",
              tabKey === "joyspace" ? "23" : "22",
              categoryId
            );
            const checkParames = {
              pageTitle: fileMsg.name,
              toFolderId: categoryId
            };
            const bizExtend: any = {
              fileName: fileMsg.name,
              id: fileMsg.id,
              mid: fileMsg.mid,
              url: fileMsg.url,
              from: fileMsg.from
            };
            try {
              if (selectedSession.sessionType === SessionType.GROUP) {
                bizExtend.groupId = fileMsg.sessionId;
              } else {
                bizExtend.to = parseUidFromString(convertEmployeeToString(fileMsg?.sender));
              }
            } catch(e) {
              console.log(`get extend err`, e);
            }
            const bizOptions = {
              bizName: FILE_DOWNLOAD_BIZTYPE.im,
              bizExtend: JSON.stringify(bizExtend)
            };
            const transferParames = {
              appKey: getCaption(fileMsg.url) || "41d47591b3adf037",
              downLoadURL: fileMsg.url,
              fileName: fileMsg.name,
              fileType: fileMsg.fileType || "",
              xtoken: userData.accessToken,
              transferFolderId: categoryId,
              fileSize: fileMsg.size,
              bizId: fileMsg.id,
              ...bizOptions
            };
            handlePageTransfer(
              transferParames,
              checkParames,
              close,
              message,
              updateSessionMessageMid,
              selectedSession,
              currentEmployee
            );
          }
        });
      }
    });
  }
};

/**
 * 消息已准备好发送
 * @param param
 */
// eslint-disable-next-line complexity
export function getChatMessageNode(
  sendType: MessageSendType,
  message: any,
  currentSession: Session,
  // Text 聊天记录搜索参数
  curClickItem?: any,
  searchKey?: string
): ReactNode {
  const isSupport = checkMessageSupport(message);
  if (!isSupport) {
    return <UnSupport message={message} />;
  }
  const props = getMessageItemProps(message, sendType, currentSession);
  if (message.revoke === 1) {
    // 该消息已撤回
    return <Revoke {...props} />;
  }
  switch (message.type) {
    case ChatMessageType.TEXT:
      if ((message as any).nativeId === "share_link") {
        return <HttpCard {...props} />;
      }
      return <Text {...props} curSearchMessgae={curClickItem} searchKey={searchKey} />;
    case ChatMessageType.IMAGE:
      return <Image {...props} />;
    case ChatMessageType.FILE: {
      if (props.sendType === MessageSendType.OWNER || props.sendType === MessageSendType.SELF) {
        if (
          !isSameClient(message) ||
          (isFocusEnv() && !message.downLocalPath && !message.upLocalPath)
        ) {
          return <DownloadFile {...props} />;
        } else {
          return <UploadFile {...props} />;
        }
      } else {
        return <DownloadFile {...props} />;
      }
    }
    case ChatMessageType.EGOV_FILE: {
      if (props.sendType === MessageSendType.OWNER || props.sendType === MessageSendType.SELF) {
        if (
          !isSameClient(message) ||
          (isFocusEnv() && !message.downLocalPath && !message.upLocalPath)
        ) {
          return <DownloadFile {...props} />;
        } else {
          return <UploadFile {...props} />;
        }
      } else {
        return <DownloadFile {...props} />;
      }
    }
    case ChatMessageType.VIDEO:
      return <Video {...props} />;
    case ChatMessageType.VOICE:
      return <Voice {...props} />;
    case ChatMessageType.TEMPLATE2:
      return <Share {...props} />;
    case ChatMessageType.JOYSPACEFILE:
      return <JoyspaceFile {...props} />;
    // 文件夹
    case ChatMessageType.JOYSPACEFOLDER:
      return <JoyspaceFolder {...props} />;
    // 组通知
    case ChatMessageType.GROUPNOTICE:
      return <GroupNotificationCard selectedSession={currentSession} {...props} />;
    // 组接龙
    case ChatMessageType.SOLITAIRE:
      return <SolitaireCard selectedSession={currentSession} {...props} />;
    // @ts-ignore
    case "unified_notice_message":
      return <NoticeCard {...props} />;
    case ChatMessageType.SYS: {
      if (message.flag === 100) {
        return <NoticeCard {...props} />;
      }
      return <SysMessage {...props} />;
    }
    case ChatMessageType.LOCATION_JD:
      return <Location {...props} />;
    default:
      return null;
  }
}
